export default (str) => {
  const pattern = new RegExp(
    '^((\\+\\d{1,3}(-| )?\\(?\\d\\)?(-| )?\\d{1,5})|(\\(?\\d{2,6}\\)?))(-| )?(\\d{3,4})(-| )?(\\d{3,4})(( x| ext)\\d{1,5}){0,1}$',
    'g',
  );
  return !!pattern.test(str);
};
